import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { ConformComponent } from '../../conform/conform.component';
import { PatientService, UserService } from '../../shared';

@Component({
  selector: 'app-welcomepage',
  templateUrl: './welcomepage.component.html',
  styleUrls: ['../style.component.css', './welcomepage.component.css']
})
export class WelcomepageComponent implements OnInit {
  dobvalid: boolean;
  patid: any;
  maxdate: boolean;
  mindate: boolean;
  showinvaild1: boolean;
  dateform: any;
  public dateformat = environment.dateFormat;
  public bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
  showinvaild: boolean = false
  patname: any = '';
  public timealert = environment.timelimit;
  public user: any = {
    dob: '',
  }
  public bobMaxDate = new Date();
  welcome: any;
  modalRef: any;
  expires: MatDialogRef<ConformComponent>;
  public datenew = new Date("01/01/1800");
  resdata: any;
  notmatched: boolean = false;
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm', backdrop: 'static' });
  }
  constructor(
    public datepipe: DatePipe,
    private toastr: ToastrService,
    private patientservice: PatientService,
    private routerr: ActivatedRoute,
    private modalService: BsModalService,
    private nav: Router,
    private dialog: MatDialog,
    private localeService: BsLocaleService,
    private userService: UserService
  ) {
    enGbLocale.invalidDate = '';
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
  }

  ngOnInit() {



    this.routerr.params.subscribe(params => {
      this.patid = params
      this.patientservice.changeNav(params['id'])
      this.patid = params['id']
      ////////console.log(this.patid);
    });


    this.patientservice
      .getwelcomepat(this.patid)
      .subscribe(
        data => {
          //alert(JSON.stringify(data))
          if (data.status == 'failure') {
            this.expires = this.dialog.open(ConformComponent, { hasBackdrop: true, disableClose: true });
            this.expires.componentInstance.message = data.message;
          }
          else {
            this.patname = data.patientName;
            if(data?.email) this.getPreferredLanguage(data?.email);
            if (data.dateFormat == 'DDMMYYYY') {
              this.dateformat = 'DD/MM/YYYY'
              this.dateform = 'dd/MM/yyyy'

              this.patientservice.us_Patient = false;

              if (navigator.userAgent.search("iPhone") != -1) {
                this.nav.navigateByUrl('/appstore')
              }
              if (navigator.userAgent.search("Android") != -1) {
                this.nav.navigateByUrl('/appstore')
              }
            } else {
              this.dateformat = 'MM/DD/YYYY'
              this.dateform = environment.dateFormat
              if (navigator.userAgent.search("iPhone") != -1) {
                this.nav.navigateByUrl('/appstore')
                location.href = "https://apps.apple.com/us/app/rc-coach/id1475273242";
              }
              if (navigator.userAgent.search("Android") != -1) {
                this.nav.navigateByUrl('/appstore')
                location.href = "https://play.google.com/store/apps/details?id=com.ind.solvedge.recoverycoach";
              }
            }
            this.bsConfig = { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat }
          }
          // ////console.log("name",this.patname)
        }, err => {
          this.dialog.open(ConformComponent, { hasBackdrop: true, disableClose: true });
          /* this.errors.message.replace('Authentication Failed:','') */
        }
      );

  }


  getPreferredLanguage(targetEmail) {
		const credential = {
		  'userName': targetEmail
		}
		this.userService.getLanguageConfig(credential).subscribe(
		  langConfigRes => {
			if(langConfigRes && langConfigRes.hasOwnProperty("multiLanguageRequired")) {
			  if(langConfigRes?.multiLanguageRequired) {
          this.userService.setCurrentLanguage(langConfigRes?.preferredlanguage)
			  }
			}
		});
	}

  checkinvaild(id) {
    // ////console.log("id",id)
    if (id == "Invalid Date") {
      this.showinvaild = true;


    } else {
      this.showinvaild = false
    }
  }
  saveUser(userForm: NgForm, result) {
    //////console.log("result",result.value);

    this.user.dob = this.datepipe.transform(this.user.dob, 'yyyy-MM-dd');
    // ////console.log("dob",this.user.dob)
    this.patientservice
      .getwelcome(this.patid, this.user.dob)
      .subscribe(
        data => {

          window.localStorage['randId'] = this.patid//////console.log(data);
          if (data.userInfo.status == "success") {
            this.nav.navigate([`/uservalidate`])
          }
          else if (data.userInfo.status == "failure") {

            this.notmatched = true;
            userForm.reset();
          }
          else {
            this.resdata = "Unauthorized Access";
            this.modalRef = this.modalService.show(result, { class: 'modal-sm', backdrop: "static" });

          }
        }
      );

  }
  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }
    if (event.target.value.length == 10) {
      this.dobvalid = true
    } else {
      this.dobvalid = false
    }
  }
  checkdate(id) {


    let date
    if (id != 'Invalid Date')
      date = this.datepipe.transform(id, 'yyyy-MM-dd');
    let curentdate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    if (date <= "1800-01-01") {

      this.mindate = true;
      this.maxdate = false;
      //this.notmatched = false
    }
    else if (date > curentdate) {
      this.mindate = false;
      this.maxdate = true;
      //this.notmatched = false
    }
    else if (date >= "1800-01-01" && date < curentdate) {
      this.mindate = false;
      this.maxdate = false;

    }
    else {
      this.mindate = false;
    }

  }

  checkempty1(id) {

    let date
    if (id != 'Invalid Date')
      date = this.datepipe.transform(id, 'yyyy-MM-dd');
    let curentdate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    if (id == '' || id == null || id == 'Invalid Date') {

      this.showinvaild1 = true;
      this.mindate = false;
      this.maxdate = false;
    } else if (id != '' && id != null && date <= "1800-01-01") {
      this.mindate = true;
      this.showinvaild1 = false;
      this.maxdate = false;
    } else if (id != '' && id != null && date > curentdate) {
      this.maxdate = true;
      this.showinvaild1 = false;
      this.mindate = false;
    } else {
      this.showinvaild1 = false;
      this.mindate = false;
      this.maxdate = false;
    }

  }

}
